import {animationOnScroll} from "../modules/animationOnScroll";

export function postFilters(){
    let $holderPosts = $('.holder-posts-list');
    let $filterForm = $('form.post-filters');

    $filterForm.on('change', 'select', function () {
        let currentURL = window.location.protocol + "//" + window.location.host + window.location.pathname + '?' + $filterForm.serialize();
        window.history.pushState({path: currentURL}, '', currentURL);

        let data = {
            'action': 'filter_posts',
            'data': $filterForm.serializeArray(),
            'paged': 1
        };

        $.ajax({
            url: ajaxvars.ajaxurl,
            data: data,
            type: 'POST',
            success: function (response) {
                $holderPosts.html(response);
                animationOnScroll();
            },
        });
    });

    $holderPosts.on('click', '.pagination a', function (e) {
        e.preventDefault();

        let data = {
            'action': 'filter_posts',
            'data': $filterForm.serializeArray(),
            'paged': $(this).attr('data-num')
        };

        $.ajax({
            url: ajaxvars.ajaxurl,
            data: data,
            type: 'POST',
            success: function (response) {
                $holderPosts.html(response);
                $('html,body').animate({scrollTop: $filterForm.offset().top - $('.header').innerHeight()}, 'slow');
                animationOnScroll();
            },
        });
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/postFilters.js